import { Controller } from 'react-hook-form';
import RichTextEditor from '@molecules/RichTextEditor';

export default function WaiverForm({ editable }: { editable: boolean }) {
    return (
        <Controller
            name="waiver"
            render={({ field: { value, onChange } }) => (
                <RichTextEditor
                    onChange={editable ? (_, editor) => onChange(editor.getData()) : undefined}
                    data={value}
                />
            )}
        />
    );
}
